import { render, staticRenderFns } from "./ChangeEmailManager.vue?vue&type=template&id=6200d284&"
import script from "./ChangeEmailManager.vue?vue&type=script&lang=ts&"
export * from "./ChangeEmailManager.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeEmailManager.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports